import React from 'react'
import { Pie } from 'react-chartjs-2'



function PieChart({ title, countryName, graphType, color, data }) {
    const state = {
        labels: ['Other cases', graphType],
        datasets: [
          {
            backgroundColor: [
              "#FF8B3D",
              color,
            ],
            hoverOpacity: [
                0.5,
                0.5
            ],
            data: [100 - data, data]
          }
        ]
      }
    return(
        <div>
            <Pie
                data={state}
                options={{
                    elements: {
                        arc: {
                            borderWidth: 0.35
                        }
                    },
                    title: {
                        display: true,
                        text: title + " in " + countryName,
                        fontSize: 20
                    },
                    legend:{
                        display: true,
                        position: 'right'
                    }
                }}
            />
        </div>
    )
}

export default PieChart;